import { Modal, Typography, Box } from '@mui/material';
import { ReactComponent as Close } from '../assets/icon/Close.svg';
import PlainButton, { UnileverButton } from './ButtonComponents';
import { ReactComponent as DeletePopUpIcon } from '../assets/icon/DeletePopUpIcon.svg';
import { useEffect, useState } from 'react';
import { usePromptLibraryContext } from '../context/PromptLibraryContext';
import { deleteMyPrompt } from '../service/apiServices';
import { useAzureData } from '../context/AzureContext';
import DropDownComponent, { RadioButtonGroup } from './inputField';
import { ReactComponent as EditPrompt } from '../assets/icon/EditPrompt.svg';

export default function DeleteModal({
  popUpType = '',
  open = false,
  handleClose = () => {},
  headerName,
  description1,
  description2,
  queryData = { promptID: '', versionID: '', radiobtn: [] },
  handleEdit = (a) => {
    return a;
  },
  versionDetail = { selected: 0, total: 0, newVersion: 0 },
  versionList = []
}: {
  popUpType?: string;
  open?: boolean;
  handleClose?: () => void;
  headerName?: string;
  description1?: string;
  description2?: string;
  queryData?: {
    promptID: string;
    versionID: string;
    radiobtn?: { id: number; text: string; checked: boolean }[];
  };
  handleEdit?: (a: any) => {};
  versionDetail?: { selected?: number; total?: number; newVersion?: number };
  versionList?: {}[];
}) {
  const { getPromptlibraryData } = usePromptLibraryContext();
  const [isLoading, setLoading] = useState(false);
  const { apiToken } = useAzureData();

  const optionsList = {
    delete: ['Delete master prompt', 'Delete Version'],
    edit: ['Save to this Version', 'Save as a new Version']
  };
  const isEditPrompt = popUpType === 'editPrompt';
  const texts = isEditPrompt ? optionsList?.edit : optionsList?.delete;

  const [radiobtn, setRadioBtn] = useState([
    { id: 0, text: texts[0], checked: false },
    { id: 1, text: texts[1], checked: false }
  ]);

  const activeButton = () => {
    const temp = radiobtn?.map((item) => item?.checked);
    return temp?.some(Boolean);
  };

  const [deletePromptQuery, setDeletePromptQuery] = useState();

  useEffect(() => {
    if (open) {
      setDeletePromptQuery(queryData);
    } else {
      setDeletePromptQuery([]);
    }
  }, [open]);

  const handleDeleteButton = async () => {
    // console.log(queryData, 'vvvqueryData', deletePromptQuery);
    setLoading(true);
    try {
      await deleteMyPrompt({ ...deletePromptQuery, radiobtn: radiobtn }, apiToken)?.then(() => {
        getPromptlibraryData();
      });
    } catch (error) {
      console.error('Error while adding prompt:', error);
      alert(error);
    } finally {
      handleClose();
      setLoading(false);
    }
  };

  const handleRadioButton = (selectedId: number) => {
    const updated = radiobtn.map((item, index) => ({
      ...item,
      checked: index === selectedId
    }));
    setRadioBtn(updated);
  };

  const availableOption = versionList?.map((item: { promptVersion: string }) => {
    return { title: item?.promptVersion, id: parseInt(item?.promptVersion) };
  });

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="alignDataCenter">
      <Box
        className="d-flex flex-column align-items-center  justify-content-evenly"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 1)',
          border: 'none',
          width: '580px',
          minHeight: '417px',
          margin: 'auto',
          borderRadius: '8px',
          padding: 20
        }}>
        {isEditPrompt ? <EditPrompt /> : <DeletePopUpIcon />}

        <div className="p-4" style={{ paddingTop: 0 }}>
          <div className="d-flex flex-column  align-items-center">
            <div
              className="h6 w600 un_standard_color text-center"
              style={{
                margin: '10px 0',
                color: isEditPrompt ? 'var(--uni_std_clr)' : 'var(--red-color)'
              }}>
              {headerName}
            </div>
            <p className="h6 w400 text-center" style={{ fontWeight: 400 }}>
              {description1}
              <u>{description2}</u>
            </p>
          </div>{' '}
          {/* <Close style={{ cursor: 'pointer' }} onClick={handleClose} /> */}
        </div>
        <div className="w-100 h-25 p-2 d-flex flex-column justify-content-evenly">
          <RadioButtonGroup
            options={radiobtn}
            handleSelection={(a) => handleRadioButton(a)}
            versionDetail={versionDetail}
            isEditPrompt={isEditPrompt}
            newVersion={versionDetail?.newVersion || 0}
          />
        </div>
        {!isEditPrompt && radiobtn[1]?.checked && (
          <div className="w-100">
            <DropDownComponent
              fieldName={'Select Version'}
              optionName={'Version'}
              options={availableOption}
              isMandatory={true}
              // paramName = '',
              handleSelection={(a?: string, b?: string) => {
                setDeletePromptQuery({
                  ...deletePromptQuery,
                  versionID: versionList?.filter((item) => item?.promptVersion == b)?.[0]
                    ?.version_id
                });
              }}
            />
          </div>
        )}
        <Box
          className="d-flex justify-content-end w-100 "
          style={{ borderTop: '1px solid var(--uni_std_clr)', paddingTop: 20 }}>
          <PlainButton
            buttonAction={handleClose}
            styleClass={{
              color: 'var(--uni_std_clr)',
              borderShadow: 'rgba(0, 0, 0, 0.05)',
              marginRight: '10px'
            }}>
            Cancel
          </PlainButton>
          {isEditPrompt ? (
            <UnileverButton
              disabled={!activeButton()}
              buttonAction={() => {
                handleEdit(radiobtn);
              }}>
              {isLoading ? 'Loading' : 'Save Prompt'}
            </UnileverButton>
          ) : (
            <PlainButton
              disabled={!activeButton()}
              buttonAction={handleDeleteButton}
              styleClass={{ color: 'var(--red-color)' }}>
              {isLoading ? 'Loading' : 'Delete'}
            </PlainButton>
          )}
        </Box>
      </Box>
    </Modal>
  );
}
